import {
  Wrench,
  ShieldCheck,
  Gauge,
  Droplets,
  ClipboardCheck,
  Disc3,
  Car,
  Cog,
  Sparkles,
  Battery,
  Snowflake,
  CircleDot,
  type LucideIcon,
} from "lucide-react";

/**
 * Maps the shared Service.icon key (lucide-style) to a concrete icon component,
 * with a sensible fallback so an unknown key never breaks the tile.
 */
const ICONS: Record<string, LucideIcon> = {
  wrench: Wrench,
  "shield-check": ShieldCheck,
  shield: ShieldCheck,
  gauge: Gauge,
  droplets: Droplets,
  oil: Droplets,
  "clipboard-check": ClipboardCheck,
  clipboard: ClipboardCheck,
  disc: Disc3,
  brakes: Disc3,
  tyre: CircleDot,
  tyres: CircleDot,
  car: Car,
  cog: Cog,
  service: Cog,
  sparkles: Sparkles,
  battery: Battery,
  aircon: Snowflake,
  snowflake: Snowflake,
};

export function ServiceIcon({
  icon,
  size = 26,
  className,
}: {
  icon?: string;
  size?: number;
  className?: string;
}) {
  const Cmp = (icon && ICONS[icon]) || Wrench;
  return <Cmp size={size} className={className} strokeWidth={1.6} aria-hidden="true" />;
}
